module.exports = __webpack_public_path__ + "img/icon_news.0b43356f.svg";